import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FmBasicModal, FmButton, FmCheckBox, FmText, FmUnderlineNav } from "../..";
import { useIsMobile } from "../../../Hooks";
import { GeneralState } from "../../../Redux";

import useStyles from "./FmClearStepModal.style";

interface FmClearStepModalProps {
  img: any;
  isOpen: any;
  onClose: any;
  clearModalAction: any;
}

const FmClearStepModal = ({ img, isOpen, onClose, clearModalAction }: FmClearStepModalProps) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  let checkBoxClicked = false;

  const handleChange = (e: any) => {
    checkBoxClicked = e.target.checked;
  };

  const handleClearMyData = () => {
    if (checkBoxClicked) {
      dispatch(GeneralState.Actions.setShowClearThisStepModal(false));
    }

    clearModalAction();
    onClose();
  };

  return (
    <FmBasicModal img={img} onClose={onClose} isOpen={isOpen}>
      <div className={isMobile ? classes.mobile_rightSide : classes.rightSide}>
        <div className={classes.mobile_box}>
          <span className={isMobile ? classes.mobile_title : classes.title}>{t("clearStepPopup.title")}</span>
          <span className={isMobile ? classes.mobile_subTitle : classes.subTitle}>{t("clearStepPopup.subTitle")}</span>
          <div className={classes.dontShowContainer}>
            <div className={classes.checkboxContainer}>
              <FmCheckBox name="dontShowAgain" required={false} onChange={(e: any) => handleChange(e)} />
            </div>
            <FmText>{t("saveProcessPopup.dontShowThisMessage")}</FmText>
          </div>
        </div>
        {isMobile ? (
          <div className={classes.mobile_buttons_container}>
            <FmButton fullWidth="fullWidth" onClick={handleClearMyData}>
              {t("clearStepPopup.clear")}
            </FmButton>
            <div className={classes.mobile_noThanks}>
              <FmUnderlineNav title={t("clearStepPopup.noGoBack")} onClick={onClose} />
            </div>
          </div>
        ) : (
          <div className={classes.buttons_container}>
            <FmButton fullWidth={"whiteButton"} onClick={onClose}>
              {t("clearStepPopup.noGoBack")}
            </FmButton>

            <FmButton fullWidth="regular" onClick={handleClearMyData}>
              {t("clearStepPopup.clear")}
            </FmButton>
          </div>
        )}
      </div>
    </FmBasicModal>
  );
};

export default FmClearStepModal;
